<template>
    <div class="w-full px-4">
        <div class="grid grid-cols-1 gap-4">
            <div  :class="borderClasses">
                <div class="flex">
                    <div class="flex-1">
                        <div :class="backgroundClasses"
                            style="border-top-left-radius: 0.25rem;border-bottom-right-radius: 0.25rem;">
                            {{ title }}
                        </div>
                    </div>
                    <div class="flex-0 px-4 py-1" v-if="button">
                        {{ button }}
                    </div>
                </div>
                <div class="pt-2 pb-2">
                    <slot></slot>
                </div>

            </div>
        </div>
    </div>

</template>

<script>
import { formatMemorySize } from "../flash/util"
export default {
    props: {
        variant: {
            type: String,
            default: "green", // default variant
            validator: (value) => ["green", "dark", "darker", "red"].includes(value)
        },

        button: {
            type: String,
        },
        title: {
            type: String,
            required: true
        }
    },
    computed: {
        borderClasses() {
            var classes = "border border-1 rounded-lg w-full border-" + this.variant;
            return classes
        },
        backgroundClasses() {
            var classes = "component-headline text-sm inline-block px-4 py-1 font-bold bg-" + this.variant;
            return classes
        }
    }
};
</script>

<style scoped>
/* Table styling */
/*   
  td,th {
    text-align: left;
  } */
</style>